module.exports = __webpack_public_path__ + "static/media/gordijnen-3.1827046d.jpg";